// SPEC-ANALYTICS-USAGE-SORT-W1-01 (D-068): 分析ページの page_key 一元定義 + 利用ソート定数。
// 将来の権限マトリクス page_key と同一規約で共用 (F3)。

export const PAGE_KEY = {
  FORECAST:            'forecast',
  BOOTH_RANKING:       'booth_ranking',
  PAYOUT_TREND:        'payout_trend',
  DMA7:                'dma7',
  PRIZE_COST_RECOVERY: 'prize_cost_recovery',
  STORE_COMPARE:       'store_compare',
  PROFIT_CALENDAR:     'profit_calendar',
  COLLECTION_EXPORT:   'collection_export',
  COLLECTION_PDF_BULK: 'collection_pdf_bulk', // D-453 集金PDF一括
  MONTHLY_TARGET:      'monthly_target', // SPEC-ADMIN-MONTHLY-TARGET-UI-01 (D-205b)
  MACHINE_RANKING:     'machine_ranking', // SPEC-MACHINE-RANKING-V1 (D-489) 機械別月次ランキング
  PRIZE_RANKING:       'prize_ranking',   // SPEC-PRIZE-DAILY-RANKING-V1 (D-569) 景品別日売りランキング
  OPS_HEALTH_RADAR:    'ops_health_radar', // SPEC-OPS-HEALTH-RADAR-V1 (D-574) 経営レーダー(6軸)
  ORDER_ACK_AUDIT:     'order_ack_audit', // SPEC-ORDER-DOC-TEXT-EXTRACT-V1 (D-575) 請書の取込状況
  DAILY_SALES_PAYOUT:  'daily_sales_payout', // SPEC-DAILY-SALES-PAYOUT-LIST-V1 (D-528) 日別売上・払出
  TARGET_DRAFT:        'target_draft', // SPEC-MONTHLY-TARGET-DRAFT-BOOTH-MEDIAN-V1 (D-795) 月次目標の叩き台
  MODEL_MONTHLY_AVG:   'model_monthly_avg', // SPEC-MODEL-MONTHLY-AVERAGE-01 (D-926) 機種別 月平均売上
  NICELAND_SLIP:       'niceland_slip', // D-992 ナイスランド宛 集金伝票
  PRIZE_PAYOUT_ANALYSIS: 'prize_payout_analysis', // D-1072 景品別 適正出率
}

// score = view_count + total_seconds / USAGE_SECONDS_PER_CLICK (1分の滞在 = 1クリック相当)。将来調整はここ1箇所。
export const USAGE_SECONDS_PER_CLICK = 60
// 1回の滞在秒 加算上限 (放置タブ対策)。
export const USAGE_DWELL_CLIP_SECONDS = 600

// SPEC-FEATURE-USAGE-PROBE-V1 (D-524): 「選んだ5機能だけ」の利用計測。
//   ★新しい基盤は作らない。既存の page_usage_stats(D-068)へ相乗りする。
//   ★ページ計測と同じ表に入るので、名前空間を feat: で分ける。
//     既存の分析ソート(sortTilesByUsage)は TILES の key で引く実装なので feat: 行を見に行かない
//     = 除外を足さなくても壊れない(実コードを読んで確認。AC5)。
//   ★付け替えるときはこの 5 個を差し替えて呼び出し位置を直す(画面から選ぶ仕組みは作らない=案C)。
export const FEATURE_PAGE_KEY_PREFIX = 'feat:'
//   ★D-627 で 3 個を差し替えた。SWIPE_SAVE / OCR_READ / PRIZE_SEARCH は「使われすぎていて
//     もう測る意味が無い」ため削除し、呼び出し位置ごと外した(ひろ指示)。
export const FEATURE_KEY = {
  ROUTE_NAVI:          'route_navi',           // 巡回ルートからマップナビを開始した
  ROUTE_REORDER:       'route_reorder',        // 巡回ルートをドラッグで並べ替えた(実際に順序が変わったときだけ)
  // D-627 追加。
  //   ★実装上の入口は「機械名の長押し」(D-593 SPEC-MANUAL-LONGPRESS-V1)。ボタンではない。
  //     /manual/{model_id} への遷移はこの 1 箇所しか無いことを raw grep で確認済み。
  MACHINE_MANUAL_VIEW: 'machine_manual_view',  // 機種マニュアルを開いた
  //   ★履歴行はタップで開閉するトグル。開いたときだけ数える(閉じるのは利用ではない)。
  CHANGER_EXPAND:      'changer_expand',       // 両替機の履歴行をタップして展開した
  //   ★補充が実際に記録されるのは集金タブの保存だけ(payload.restocked)。保存が成功し、
  //     かつ補充金種が空でないときだけ数える。
  CHANGER_RESTOCK_TAP: 'changer_restock_tap',  // 両替機の補充を記録した
}
